import { createContext, FC, ReactNode, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { googleApiLibraries } from '../constants';

export interface GoogleApiContextShape {
	apiKey?: string;
	isLoaded: boolean;
}

const GoogleApiContext = createContext<GoogleApiContextShape>({ isLoaded: false });

export const useGoogleApiContext = () => useContext(GoogleApiContext);

export interface GoogleApiContextProviderProps {
	apiKey?: string;
	children: ReactNode;
}

export const GoogleApiContextProvider: FC<GoogleApiContextProviderProps> = ({ apiKey, children }) => {
	if (!apiKey) {
		throw new Error('Google API key is required');
	}

	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: apiKey,
		libraries: googleApiLibraries,
	});

	return <GoogleApiContext.Provider value={{ apiKey, isLoaded }}>{children}</GoogleApiContext.Provider>;
};
